import qs from 'query-string';

export default function useGameQueryParams() {
  const parsed = qs.parse(location.search);

  return {
    gamePlayInfoId: parsed?.demoId?.toString(),
    demoId: parsed?.demoId?.toString(),
    rp: parsed?.rp?.toString(),
  };
}
